import { PieceSlider, PieceDescription, PieceUnorderedList } from '@store/index';
const PUBLIC_URL = process.env.REACT_APP_URL;

const authenticationiOS = {
    name: 'Authentication iOS',
    slug: 'authentication-ios',
    description: 'Small sub-project that adds supporting OAuth protocol for iOS app',
    cover: {
        url: `${PUBLIC_URL}/portfolio/authentication-ios/cover.jpg`,
        license: {
            link: 'http://www.freepik.com',
            text: 'Designed by Freepik'
        }
    },
    prominentColor: 'rgb(225,223,89)',
    pieces: [
        {
            type: 'slider',
            images: [
                {
                    url: `${PUBLIC_URL}/portfolio/authentication-ios/cover.jpg`,
                    license: {
                        link: 'http://www.freepik.com',
                        text: 'Designed by Freepik'
                    }
                }
            ]
        } as PieceSlider,
        {
            type: 'description',
            title: 'Role',
            description: 'iOS developer for iPhone app.',
        } as PieceDescription,
        {
            type: 'unordered list',
            title: 'Main Technologies',
            items: ['Swift', 'Alamofire', 'ReSwift', 'ObjectMapper', 'FBSDKLoginKit'],
        } as PieceUnorderedList,
    ],
}

export default authenticationiOS;


// WEBPACK FOOTER //
// ./src/store/portfolio/authentication-ios.tsx